module.exports = __webpack_public_path__ + "media/images/weather/302_night-0e77a39e3e50034a96c4390918e4fb8b.png";